var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _polygon, _polygon2, _polygon3, _polygon4, _g2, _polygon5, _polygon6, _polygon7, _polygon8, _path26, _polygon9, _g3, _polygon10, _g4, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _polygon11, _polygon12, _path68, _rect, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _ellipse, _path83, _path84, _path85, _path86, _path87, _ellipse2, _path88, _path89, _path90, _path91, _polygon13, _path92, _path93, _path94, _path95, _path96, _path97, _circle, _circle2, _path98, _path99, _path100, _path101, _path102;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M823.45,288.3,682.28,660.89H164.12a41.25,41.25,0,0,1-40.33-32.55l-83-383.51a45.38,45.38,0,0,1,28.41-52.08L337.31,92.08l9.46-3.55,10.81-4.07,127-47.7,4-1.51,29-10.89a42.56,42.56,0,0,1,41.69,6.73l74.62,60.25,8.37,6.76.38.31,21.62,17.45L808.21,232A49.68,49.68,0,0,1,823.45,288.3Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.45,288.3,682.28,660.89H164.12a41.25,41.25,0,0,1-40.33-32.55l-83-383.51a45.38,45.38,0,0,1,28.41-52.08L337.31,92.08l9.46-3.55,10.81-4.07,127-47.7,4-1.51,29-10.89a42.56,42.56,0,0,1,41.69,6.73l74.62,60.25,8.37,6.76.38.31,21.62,17.45L808.21,232A49.68,49.68,0,0,1,823.45,288.3Z",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M701.76,596l-68.57,2.35c-24.09-.64-13.9-42.35-13.9-42.35l13.23-80.1.67-4.06a9.89,9.89,0,0,0,1.1,2.16c5,6,16,26,16,26,3,8,7,8,7,8a13.59,13.59,0,0,0,3.63.63C657.55,535.21,649.29,572,649.29,572l16.1.26Z",
    fill: "#f9b499"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M660.92,508.58C657.55,535.21,649.29,572,649.29,572l-13,1,9-7,7-53c-9-6-19.77-37.1-19.77-37.1l.67-4.06a9.89,9.89,0,0,0,1.1,2.16c5,6,16,26,16,26,3,8,7,8,7,8A13.59,13.59,0,0,0,660.92,508.58Z",
    fill: "#f7a48b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M678.85,355.53s-2,31.68,15.74,38.55c0,0,23.7,7.87,32.7-20.13,0,0-19.12,4.13-20.79-5.87a28.73,28.73,0,0,0-.89-4c-1.9-5.79-7.35-19.19-17-18.73C688.6,345.36,686.41,350.11,678.85,355.53Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.14,558.17,163,566.6s-43.73,7.07-56.73,20.07a6.85,6.85,0,0,1-8,2s-8.76-8.88-16.88.56l-5.12,5.44s-16-3-21,2c0,0-13,16-9,18,0,0,1.44,1.44,3.71-1.18a10.72,10.72,0,0,1,4.44-3.07c4.41-1.57,12.6-3.83,18.85-1.75l114.35-16.94,1.4-29a66.57,66.57,0,0,1-10.47-3.87S170,557.68,164.14,558.17Z",
    fill: "#f7a48b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.29,384.67c-1,2-5,4-5,4-5,2-14,1-14,1-5.21,3.72-18.75,9.11-25.32,11.62a23.45,23.45,0,0,1-7.45,1.53l-20.28.78a1,1,0,0,0-1,1v71.08c-23,6-57-2.39-57-2.39V414.67c0-26,15-36,15-36,0-5-1.9-15.87-1.9-15.87l.09,0c3.85,6.07,9.5,9.91,15.81,9.91a15.24,15.24,0,0,0,3.64-.44l1.36,3.44c4,0,32.71,10.5,32.71,10.5,12.72,4.5,15.29,2.5,15.29,2.5,13-7,29-8,29-8,6.06-5.2,10.62-5.89,11.74-6a.24.24,0,0,1,.25.26,4.49,4.49,0,0,1-2.95,3.72s0,0,0,0c6,2,8-2,8-2,3-2,1,2,1,2,3,0,2,2,2,2C312.29,382.67,310.29,384.67,310.29,384.67Z",
    fill: "#f9b499"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.29,380.67c-2.11,1.91-5.09,3.41-8,2.93,2.77-.93,5.15-2.21,8-2.93Z",
    fill: "#f7a48b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M311.29,383.15c-1.89,1.63-4.46,3-7,2.52,2.35-.94,4.46-2.11,7-2.52Z",
    fill: "#f7a48b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.29,389.67c-5.21,3.72-18.75,9.11-25.32,11.62a23.45,23.45,0,0,1-7.45,1.53l-20.28.78s-1.93-1-1.94-10c0,0,1.63,3.93,4.31,5h20.53l-1.85-8,5,8S289.29,387.67,291.29,389.67Z",
    fill: "#f7a48b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M679.29,337a39,39,0,0,1-1.06,9.12c-2.63,11-9.89,18.88-18.44,18.88a14.29,14.29,0,0,1-2.93-.31c-9.38-2-16.57-13.66-16.57-27.69,0-15.46,8.73-28,19.5-28S679.29,321.49,679.29,337Z",
    fill: "#f9b499"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M642,325.58s-2.37,5.67-1.31,16.79c0,0-6.37-11.42-5.37-23.42,0,0,1-15,18-12,0,0,16.13-9,30.57,2a28,28,0,0,1,9,24.34,31.3,31.3,0,0,1-11.49,20.26,58.74,58.74,0,0,1-6.11,4.4,118.79,118.79,0,0,0,2.94-11.88l1-7.43s-7.26,7-15.11-3.34L654.29,324S649.65,326.21,642,325.58Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M678.23,346.07c-1.07,9.11-2.94,11.88-2.94,11.88l-3,12c-2,4-3,11-3,11-4,14-17.71,13.12-17.71,13.12-9.72-.89-5.29-19.12-5.29-19.12a51,51,0,0,1,10.57-5.56v-4.75a14.29,14.29,0,0,0,2.93.31C668.34,365,675.6,357.06,678.23,346.07Z",
    fill: "#f9b499"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M694.29,471.87a7.86,7.86,0,0,1-5.13,8c-4.17,1.58-11.42,5.75-14.87,16.09,0,0-2.73,10.9-11,12.45a10.22,10.22,0,0,1-2.38.18,13.59,13.59,0,0,1-3.63-.63s-3.63,0-6.57-6.91v0c-.15-.34-.29-.69-.43-1.07,0,0-11-20-16-26a9.89,9.89,0,0,1-1.1-2.16,31.86,31.86,0,0,1-1.9-11.84l-1.36-20.37-.64-9.63s-1.86-21.38,4.28-32.77a22.66,22.66,0,0,0,1.44-3.32l5.28-15.27a6.38,6.38,0,0,1,.31-1c.57-1.53,2.1-4,5.69-2.59,0,0-4.43,18.23,5.29,19.12,0,0,13.71.88,17.71-13.12,0,0,1-7,3-11a10.67,10.67,0,0,1,2.43-.65c1.63-.2,3.48.08,3.51,2.44,0,0-5.94,19.21-1.94,27.21,0,0,6,9,15,8,0,0,7,21,2,39,0,0-2,12,0,21a24.74,24.74,0,0,1,1,4.84S694.29,471.84,694.29,471.87Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M656.86,364.64v10.81s14.23-7.5,15.83-17.5A16.06,16.06,0,0,1,656.86,364.64Z",
    fill: "#f7a48b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M821.29,602c-3-1-11-1-11-1a46.47,46.47,0,0,1-19-4c-5.08-2.54-13.38-3.06-18.77-3.11h0c-3.08,0-5.21.11-5.21.11l-82,2c-20,0-19-12-19-12l-2-26c-.83-17.45-1-41.82-1-49.55,8.26-1.55,11-12.45,11-12.45,3.45-10.34,10.7-14.51,14.87-16.09a7.86,7.86,0,0,0,5.13-8s0-.05,0-.08h0a24.31,24.31,0,0,1,2.73,8.14c4.84,24.73.27,86,.27,86h13c21-2,46,12,46,12,19,7,31,3,31,3,12-3,15,7,15,7,3,5,11,6,11,6,10,1,12,5,12,5C826.29,602,821.29,602,821.29,602Z",
    fill: "#f9b499"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M772.52,593.84h0c-3.08,0-5.21.11-5.21.11l-82,2c-20,0-19-12-19-12l-2-26c-.83-17.45-1-41.82-1-49.55,8.26-1.55,11-12.45,11-12.45,3.45-10.34,10.7-14.51,14.87-16.09a7.86,7.86,0,0,0,5.13-8s0-.05,0-.08h0a24.31,24.31,0,0,1,2.73,8.14s-16.72,22.57-23.86,36.32a22.34,22.34,0,0,0-2.47,12c1,14.09,4,51.43,5.6,54.67,0,0,9-11,16-14,0,0-23.27,20.92-8.63,21.46C683.66,590.41,765.76,589.74,772.52,593.84Z",
    fill: "#f7a48b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M690.44,345.45c-4.86,9.5-11.59,11.78-11.59,11.78v-1.7c5.56-3.42,9.75-10.17,9.75-10.17h1Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M640.6,377.54a6.38,6.38,0,0,0-.31,1L635,393.86a22.66,22.66,0,0,1-1.44,3.32c-6.14,11.39-4.28,32.77-4.28,32.77l.64,9.63-4.48,5.05a15.28,15.28,0,0,1-9.73,5L604.29,451l-.31-4.19L602.5,427h11.79l13.36-32.87C633,377.21,640.6,377.54,640.6,377.54Z",
    fill: "#f9b499"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M629.29,430l.64,9.63-4.48,5.05a15.28,15.28,0,0,1-9.73,5L604.29,451l-.31-4.19s15.31.19,14.31-6.81l-2-8c.25.64,5,12.84,7,8,0,0,1.56-34.54,10.28-42.77C627.43,408.57,629.29,430,629.29,430Z",
    fill: "#f7a48b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M695.85,490.16l-2.14-8.55A4.64,4.64,0,0,0,691.9,479l-6.28-4.48a13.22,13.22,0,0,1-5.33,3.17L678,483.28a4.69,4.69,0,0,0-.29,2.54l1.05,6.6a3.3,3.3,0,0,0,4,2.69l11.72-2.82A1.74,1.74,0,0,0,695.85,490.16Zm-6.27-.71-5.53,1.32a.82.82,0,0,1-1-.56l-1.49-5.08a1.05,1.05,0,0,1,.2-.92l2.24-3.82a.53.53,0,0,1,.71-.18l4.21,2.48a1.06,1.06,0,0,1,.41.68l.83,5.15A.82.82,0,0,1,689.58,489.45Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M694.29,471.87a7.86,7.86,0,0,1-5.13,8c-4.17,1.58-11.42,5.75-14.87,16.09,0,0-2.73,10.9-11,12.45a10.22,10.22,0,0,1-2.38.18,13.59,13.59,0,0,1-3.63-.63s-3.63,0-6.57-6.91v0c12.43,5.07,13.44-5.81,13.44-5.81C663,480.46,676.29,467,676.29,467a60.21,60.21,0,0,0,2.56-59.25c-13.07-15.79-4.61-37.23-4.13-38.4,1.63-.2,3.48.08,3.51,2.44,0,0-5.94,19.21-1.94,27.21,0,0,6,9,15,8,0,0,7,21,2,39,0,0-2,12,0,21a24.74,24.74,0,0,1,1,4.84S694.29,471.84,694.29,471.87Z",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M198.11,590.25h189.1s-37.95-26.67-51.87-26.67S299.62,574,299.62,574,274,553.1,257.27,553.1,198.11,590.25,198.11,590.25Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.11,590.25h189.1s-37.95-26.67-51.87-26.67S299.62,574,299.62,574,274,553.1,257.27,553.1,198.11,590.25,198.11,590.25Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M478.94,232.9H400.33l-3.87,181h86.33Zm-23.21,84.2H423.61V289.68a16,16,0,0,1,16-16h0a16,16,0,0,1,16,16Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.94,232.9H400.33l-3.87,181h86.33Zm-23.21,84.2H423.61V289.68a16,16,0,0,1,16-16h0a16,16,0,0,1,16,16Z",
    fill: "#fff"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M449.8,277.3a15.66,15.66,0,0,0-5.46-1h0a16,16,0,0,0-16,16V317.1h-4.72V289.68a16,16,0,0,1,16-16h0A15.9,15.9,0,0,1,449.8,277.3Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "479.09 240.54 400.13 242.49 400.33 232.9 478.94 232.9 479.09 240.54",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "482.79 413.92 396.48 413.92 398.02 341.84 481.2 339.42 482.79 413.92",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "497.76 234.25 387.51 234.25 442.62 164.43 497.76 234.25",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "497.76 234.25 387.51 234.25 442.62 164.43 497.76 234.25",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "546.94 343.41 546.94 489.94 332.33 489.94 332.33 343.41 345.09 343.41 345.09 356.42 357.57 356.42 357.57 343.41 370.33 343.41 370.33 356.42 382.8 356.42 382.8 343.41 395.55 343.41 395.55 356.42 408.02 356.42 408.02 343.41 420.77 343.41 420.77 356.42 433.26 356.42 433.26 343.41 446 343.41 446 356.42 458.5 356.42 458.5 343.41 471.24 343.41 471.24 356.42 483.72 356.42 483.72 343.41 496.46 343.41 496.46 356.42 508.95 356.42 508.95 343.41 521.7 343.41 521.7 356.42 534.17 356.42 534.17 343.41 546.94 343.41",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "546.94 343.41 546.94 489.94 332.33 489.94 332.33 343.41 345.09 343.41 345.09 356.42 357.57 356.42 357.57 343.41 370.33 343.41 370.33 356.42 382.8 356.42 382.8 343.41 395.55 343.41 395.55 356.42 408.02 356.42 408.02 343.41 420.77 343.41 420.77 356.42 433.26 356.42 433.26 343.41 446 343.41 446 356.42 458.5 356.42 458.5 343.41 471.24 343.41 471.24 356.42 483.72 356.42 483.72 343.41 496.46 343.41 496.46 356.42 508.95 356.42 508.95 343.41 521.7 343.41 521.7 356.42 534.17 356.42 534.17 343.41 546.94 343.41",
    fill: "#fff"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "546.94 380.5 546.94 489.94 332.33 489.94 332.33 380.5 360.76 380.5 365.13 436.78 514.14 436.78 518.51 380.5 546.94 380.5",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "521.7 439.97 521.7 590.85 357.57 590.85 357.57 439.97 370.33 439.97 370.33 452.98 382.8 452.98 382.8 439.97 395.55 439.97 395.55 452.98 408.02 452.98 408.02 439.97 420.77 439.97 420.77 452.98 433.26 452.98 433.26 439.97 446 439.97 446 452.98 458.5 452.98 458.5 439.97 471.24 439.97 471.24 452.98 483.72 452.98 483.72 439.97 496.46 439.97 496.46 452.98 508.95 452.98 508.95 439.97 521.7 439.97",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "521.7 439.97 521.7 590.85 357.57 590.85 357.57 439.97 370.33 439.97 370.33 452.98 382.8 452.98 382.8 439.97 395.55 439.97 395.55 452.98 408.02 452.98 408.02 439.97 420.77 439.97 420.77 452.98 433.26 452.98 433.26 439.97 446 439.97 446 452.98 458.5 452.98 458.5 439.97 471.24 439.97 471.24 452.98 483.72 452.98 483.72 439.97 496.46 439.97 496.46 452.98 508.95 452.98 508.95 439.97 521.7 439.97",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.13 590.85 357.59 590.85 357.59 439.97 360.41 439.97 361.13 452.98 369.13 590.85",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "510.15 590.85 521.7 590.85 521.7 439.97 518.86 439.97 518.14 452.98 510.15 590.85",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M476.77,550.24v40.61H402.49V550.24a37.13,37.13,0,0,1,37.13-37.13h0a37.13,37.13,0,0,1,37.15,37.11Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.94 599.57 265.78 599.57 270.13 394.67 270.13 381.68 282.88 381.68 282.88 394.67 295.37 394.67 295.37 381.68 308.12 381.68 308.12 394.67 320.59 394.67 320.59 381.68 333.35 381.68 333.35 394.67 345.83 394.67 345.83 381.68 358.57 381.68 358.57 394.67 362.94 599.57",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.94 599.57 265.78 599.57 270.13 394.67 270.13 381.68 282.88 381.68 282.88 394.67 295.37 394.67 295.37 381.68 308.12 381.68 308.12 394.67 320.59 394.67 320.59 381.68 333.35 381.68 333.35 394.67 345.83 394.67 345.83 381.68 358.57 381.68 358.57 394.67 362.94 599.57",
    fill: "#fff"
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "613.48 599.57 516.34 599.57 520.69 394.67 520.69 381.68 533.44 381.68 533.44 394.67 545.91 394.67 545.91 381.68 558.67 381.68 558.67 394.67 571.13 394.67 571.13 381.68 583.89 381.68 583.89 394.67 596.39 394.67 596.39 381.68 609.13 381.68 609.13 394.67 613.48 599.57",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "613.48 599.57 516.34 599.57 520.69 394.67 520.69 381.68 533.44 381.68 533.44 394.67 545.91 394.67 545.91 381.68 558.67 381.68 558.67 394.67 571.13 394.67 571.13 381.68 583.89 381.68 583.89 394.67 596.39 394.67 596.39 381.68 609.13 381.68 609.13 394.67 613.48 599.57",
    fill: "#fff"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M414.39,422.56a1.24,1.24,0,1,0,1.23,1.24A1.24,1.24,0,0,0,414.39,422.56Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M321.44,579.09a1.24,1.24,0,1,0,1.24,1.24A1.25,1.25,0,0,0,321.44,579.09Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M366,351.55l-.19-.39A.58.58,0,0,0,365,351a.61.61,0,0,0-.16.16,2.81,2.81,0,0,0-.19.39C363.89,353,366.66,353,366,351.55Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M390.42,582.23a1.85,1.85,0,0,0-.19-.37.54.54,0,0,0-.74-.21.6.6,0,0,0-.21.21,2.58,2.58,0,0,0-.19.37C388.37,583.7,391.14,583.7,390.42,582.23Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M425.06,430.12a1,1,0,1,0,1,1A1,1,0,0,0,425.06,430.12Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M590.7,457a1,1,0,0,0,0,1.94,1,1,0,1,0,0-1.94Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M372,531.15a1,1,0,1,0,1,1A1,1,0,0,0,372,531.15Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M488,394.17a1.27,1.27,0,0,0-1.8,0l0,0a1.78,1.78,0,0,0-.46,1.78,1.44,1.44,0,0,0,2.76,0A1.78,1.78,0,0,0,488,394.17Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M331.83,572.07a1.34,1.34,0,0,0-1.89,0l-.05,0a2,2,0,0,0-.44,1.8,1.43,1.43,0,0,0,1.77,1,1.41,1.41,0,0,0,1-1A2,2,0,0,0,331.83,572.07Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M286.78,474.27a1.33,1.33,0,0,0-1.88,0l0,0a2,2,0,0,0-.44,1.8,1.42,1.42,0,0,0,1.77,1,1.39,1.39,0,0,0,1-1A1.93,1.93,0,0,0,286.78,474.27Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M394.47,513.75a1.24,1.24,0,1,0-1.24-1.24A1.24,1.24,0,0,0,394.47,513.75Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M413.19,312.44a1.25,1.25,0,1,0-1.1-1.09A1.27,1.27,0,0,0,413.19,312.44Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M592.73,436.39a1.24,1.24,0,1,0-1.23-1.24A1.24,1.24,0,0,0,592.73,436.39Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M454.46,189.66a1.24,1.24,0,1,0-1.24-1.24A1.24,1.24,0,0,0,454.46,189.66Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M539.32,489.94a1.24,1.24,0,1,0-1.24-1.24A1.24,1.24,0,0,0,539.32,489.94Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M604.24,445.58c.06.12.12.24.19.36a.56.56,0,0,0,.77.2.64.64,0,0,0,.2-.2c.06-.12.12-.24.17-.36C606.33,444.12,603.56,444.12,604.24,445.58Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M419,207.46a3.49,3.49,0,0,0,.19.39.56.56,0,0,0,.77.17.73.73,0,0,0,.18-.17c.07-.13.13-.26.19-.39C421.08,206,418.31,206,419,207.46Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M410.54,301.27a3.13,3.13,0,0,0,.19.36.54.54,0,0,0,.74.21.47.47,0,0,0,.21-.21c.07-.12.13-.24.19-.36C412.59,299.8,409.82,299.8,410.54,301.27Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M600.2,552.21a2.58,2.58,0,0,0,.19.37.56.56,0,0,0,.77.2.64.64,0,0,0,.2-.2l.19-.37C602.3,550.74,599.5,550.74,600.2,552.21Z",
    fill: "#ffc727"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M383.77,506.2a1,1,0,1,0-1-1A1,1,0,0,0,383.77,506.2Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M462.58,265.43a1,1,0,1,0-1-1A1,1,0,0,0,462.58,265.43Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M472.17,229.39a1,1,0,1,0-1-1A1,1,0,0,0,472.17,229.39Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M413.46,219.58a1.32,1.32,0,0,0,1.88,0,.12.12,0,0,0,.05,0,1.75,1.75,0,0,0,.45-1.79,1.43,1.43,0,0,0-1.78-1,1.41,1.41,0,0,0-1,1A1.91,1.91,0,0,0,413.46,219.58Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M382,369a1.33,1.33,0,0,0,1.89,0l.05,0a1.8,1.8,0,0,0,.44-1.78,1.43,1.43,0,0,0-2.74,0A1.76,1.76,0,0,0,382,369Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M531.08,572.9a1.29,1.29,0,0,0,1.83.11l.1-.11a1.8,1.8,0,0,0,.45-1.77,1.43,1.43,0,0,0-1.78-1,1.41,1.41,0,0,0-1,1A1.77,1.77,0,0,0,531.08,572.9Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M495.46,469.73a1.28,1.28,0,0,0,1.82.1.52.52,0,0,0,.11-.1,1.8,1.8,0,0,0,.44-1.78,1.43,1.43,0,0,0-2.74,0A1.79,1.79,0,0,0,495.46,469.73Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05,610.44H338.58s-27.81-19.53-38-19.53-26.16,7.64-26.16,7.64-18.76-15.28-31-15.28S200.05,610.44,200.05,610.44Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.05,610.44H338.58s-27.81-19.53-38-19.53-26.16,7.64-26.16,7.64-18.76-15.28-31-15.28S200.05,610.44,200.05,610.44Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M559.55,600.12H698.07s-27.79-19.54-38-19.54-26.18,7.64-26.18,7.64S615.15,572.94,603,572.94,559.55,600.12,559.55,600.12Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M559.55,600.12H698.07s-27.79-19.54-38-19.54-26.18,7.64-26.18,7.64S615.15,572.94,603,572.94,559.55,600.12,559.55,600.12Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M559.2,643.13H757.6s-39.82-26.07-54.42-26.07-37.48,10.19-37.48,10.19-26.86-20.4-44.48-20.4S559.2,643.13,559.2,643.13Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M559.2,643.13H757.6s-39.82-26.07-54.42-26.07-37.48,10.19-37.48,10.19-26.86-20.4-44.48-20.4S559.2,643.13,559.2,643.13Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M607,588.4c.55,7.52-2.08,14.64-1.54,15.25s3.65,1.67,2.13,3.2-3.7,1-5,1.93a1.09,1.09,0,0,0-.25.23c-1.08,1.1-1.56,4.18-3.54,4.26S597,609.4,597,609.4a43.72,43.72,0,0,1-10.28-1.74c-4.94-1.55-11.82-5.3-11.16-8.3s4.35-2.57,4.79-4.08-2.55-5.09-.83-7.21a2.85,2.85,0,0,1,2.05-1c2.21-.23,5.13.73,6,.13,1.25-.85-.14-6.36,2.92-7.42s4.39,3.25,6.44,2.71,2.39-3.68,4.89-3.76S606.42,580.85,607,588.4Z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M594.88,604.33a.6.6,0,1,0,.77.15A.59.59,0,0,0,594.88,604.33Z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M593.12,603.05a42.13,42.13,0,0,1-10.87-6.61c-.62-.46-1.41.45-.79.93a44.11,44.11,0,0,0,11.14,6.79C593.31,604.41,593.85,603.33,593.12,603.05Z",
    fill: "#ebebeb"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M590.28,589.4a.61.61,0,0,0-1,.68l8.26,12.24a.6.6,0,0,0,1-.68Z",
    fill: "#ebebeb"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M598.3,586.52a44.21,44.21,0,0,1,1.94,14.54c0,.78,1.16.7,1.21,0a45,45,0,0,0-2.05-14.85C599.25,585.3,598.09,585.77,598.3,586.52Z",
    fill: "#ebebeb"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M598,584.2c-.66.42,0,1.43.68,1S598.65,583.75,598,584.2Z",
    fill: "#ebebeb"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M294.27,557c-4.8,3.73-10.75,5.14-10.93,5.8s.52,3.21-1.18,2.86-2.34-2-3.48-2.49h-.25c-1.24-.21-3.52.83-4.45-.47s1.84-2.93,1.84-2.93a35.49,35.49,0,0,1-3.44-7.74c-1.16-4-1.72-10.31.58-11.22s3.67,1.8,4.89,1.41,2.26-4,4.47-3.86a2.24,2.24,0,0,1,1.54,1c1.15,1.38,1.8,3.78,2.62,4.1,1.14.47,4.21-2.92,6.28-1.35s-.23,4.39,1.06,5.53,3.54,0,4.72,1.61S299.08,553.2,294.27,557Z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M278.16,555.94a.49.49,0,0,0-.64.28.48.48,0,0,0,.27.63.49.49,0,0,0,.37-.91Z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M278.24,554.2a33.57,33.57,0,0,1-.43-10.25c0-.61-.93-.75-1-.11a34.9,34.9,0,0,0,.43,10.5C277.41,554.94,278.37,554.82,278.24,554.2Z",
    fill: "#ebebeb"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M286.13,546.2a.5.5,0,0,0-.25-.64.48.48,0,0,0-.64.25l-4.53,11a.48.48,0,0,0,.89.37Z",
    fill: "#ebebeb"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M291.66,550.3a36,36,0,0,1-8.9,7.83c-.54.31,0,1.08.6.77a36.55,36.55,0,0,0,9.07-8C292.88,550.49,292.06,549.81,291.66,550.3Z",
    fill: "#ebebeb"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M293.07,549.06a.48.48,0,0,0-.6.32.44.44,0,1,0,.84.25A.5.5,0,0,0,293.07,549.06Z",
    fill: "#ebebeb"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "296.36 651.03 241.82 651.03 234.78 587.02 303.4 587.02 296.36 651.03",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.41 587.02 302.66 593.75 235.86 596.89 234.77 587.02 303.41 587.02",
    opacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M285.71,592a1.3,1.3,0,0,1,1.33,1.23,79.55,79.55,0,0,1-3.9,24.49C278.68,630.29,270.65,637,259.93,637a18.62,18.62,0,0,1-13.48-5.52c-11.76-11.55-11.68-37.16-11.68-38.24A1.31,1.31,0,0,1,236.1,592h0a1.22,1.22,0,0,1,1.29,1.17s0,0,0,.06c0,.26-.08,25.64,10.9,36.42a16.09,16.09,0,0,0,11.62,4.77c23.78,0,24.47-37,24.47-41.2a1.25,1.25,0,0,1,1.25-1.23Z",
    fill: "#c7c7c7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 229.69,
    y: 582.8,
    width: 78.82,
    height: 7.73,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M236.29,582.8h66.13s-13.27-9.32-18.14-9.32-12.49,3.71-12.49,3.71-9-7.3-14.84-7.3S236.29,582.8,236.29,582.8Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.29,582.8h66.13s-13.27-9.32-18.14-9.32-12.49,3.71-12.49,3.71-9-7.3-14.84-7.3S236.29,582.8,236.29,582.8Z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M246.31,661.25H444.7s-39.8-26-54.44-26-37.48,10.21-37.48,10.21S325.91,625,308.3,625,246.31,661.25,246.31,661.25Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.31,661.25H444.7s-39.8-26-54.44-26-37.48,10.21-37.48,10.21S325.91,625,308.3,625,246.31,661.25,246.31,661.25Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M230.29,343.67c0,14.3-7.49,26.18-17.36,28.56a15.24,15.24,0,0,1-3.64.44c-6.31,0-12-3.84-15.81-9.91a35.9,35.9,0,0,1-5.19-19.09c0-16,9.4-29,21-29S230.29,327.65,230.29,343.67Z",
    fill: "#f9b499"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M193.29,348.67s5.68,3,3.84-4l-1.2-7.93s-2.1-7.5,1.63-4.28c0,0,12.25,5.54,22-.58a8.3,8.3,0,0,1,4.43-1.21h4s1.22,2,2.22,11.5c0,0,10.15-7.5,4.07-11.5,0,0-2.07-1-.07-3a11.25,11.25,0,0,0,1.93-6.67,6.45,6.45,0,0,0-8.1-5.46l-.47.13s-2.5,2.11-2.43-.44c0,0,.9-3.8.29-6a.27.27,0,0,0-.49-.07,9.68,9.68,0,0,1-2.62,3.13.71.71,0,0,1-1.09-.58c-.09-2.14-1.14-7.27-9-8.06,0,0-7-2-14,7,0,0-3-5-11-5a11.25,11.25,0,0,1,4,5s-10,0-11,5c0,0-1,3,1,8,0,0-6,2-5,4,0,0,0,2,4,2,0,0-6.22,3.57-4.11,8.79a7.29,7.29,0,0,0,4.11,4.21s-5,5.19-1,10.46a8.64,8.64,0,0,0,4.15,2.86,4.44,4.44,0,0,1,2.87,2.75s2,7.52,8,5.22c0,0-3.15-3.23-5.07-11.76Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M309.29,378.67a6.64,6.64,0,0,1-6,3,49.38,49.38,0,0,1,6-3Z",
    fill: "#f7a48b"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26,366.4s6,12.2,13,15.74l8.57-2-3.57-4.5-1.36-3.44S204.23,375.13,196.26,366.4Z",
    fill: "#f7a48b"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M187.3,398.2s-5,11.47,6,26.47c0,0,13,21.14,44,31.57V412.67l-12.14,1L210,403Z",
    fill: "#f2947e"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29,541.67c1,14-10,24-10,24l-2.19.3a77,77,0,0,1-34.76-3.46c-2.18-.74-4.17-1.54-6-2.33l-1.71-.79a52.31,52.31,0,0,1-9.38-5.55c-8-4.83,0-16.17,0-16.17,6-14,9-53,9-53a25.6,25.6,0,0,1,0-7.68v0a17.57,17.57,0,0,1,.77-3.15l.09-.24.1-.24,0-.05,1.07.25c5.95,1.35,35.35,7.51,55.93,2.14Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M180.27,473.33l-.1.24Z",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M170.29,553.84a52.31,52.31,0,0,0,9.38,5.55c-17.91,2.15-24.62-6.46-26.64-10.13a3.64,3.64,0,0,1-.23-3l12.49-34.6,14.79-37.86a23.31,23.31,0,0,0-.79,10.86s-3,39-9,53C170.29,537.67,162.29,549,170.29,553.84Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M170.29,553.84a52.31,52.31,0,0,0,9.38,5.55c-17.91,2.15-24.62-6.46-26.64-10.13a3.64,3.64,0,0,1-.23-3l12.49-34.6,14.79-37.86a23.31,23.31,0,0,0-.79,10.86s-3,39-9,53C170.29,537.67,162.29,549,170.29,553.84Z",
    opacity: 0.2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29,541.67c1,14-10,24-10,24a77.45,77.45,0,0,1-36.95-3.16l26.95,2.16c11,1,12-14,12-14l2.81-55.16a6.17,6.17,0,0,0-3.9-6.06C213.1,484.67,179.3,477,179.3,477v0l.77-3.15,1.28-.28c5.95,1.35,35.35,7.51,55.93,2.14Z",
    opacity: 0.2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1,566l-2.4,15.11c-.19,1.23-.37,2.46-.48,3.69-1.67,19.8-21.93,16.9-21.93,16.9-19-1-72,9-72,9-13,3-16,1-16,1-3.5-.7-8,1.54-10.36,3a16.42,16.42,0,0,1-4.12,1.8c-10.35,2.84-15.52.25-15.52.25a13.13,13.13,0,0,0-12.05,4.89,7.06,7.06,0,0,1-1.7,1.49,1.56,1.56,0,0,1-2.37-1.22c-.17-3.54,5.12-10.16,5.12-10.16,6-11,12.93-9,12.93-9H93.29l5-5c9-10,18,0,18,0,2,3,4,1,4,1,20-20,59.79-23.53,59.79-23.53l1.3-15c1.79.79,3.78,1.59,6,2.33A77,77,0,0,0,222.1,566Z",
    fill: "#f9b499"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M181.38,560.18l-.55,6.42s9.93,10.86,39.19,12.46L222.1,566S203.47,569.69,181.38,560.18Z",
    fill: "#f7a48b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.29,
    cy: 350.17,
    rx: 4,
    ry: 5.5,
    fill: "#f9b499"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M289.88,415.43c-.44,3-2.48,4.77-5.09,5.75-5.83,2.17-14.5.49-14.5.49-6,0-13,4-13,4a116.11,116.11,0,0,1-37,12c-8,0-23-16-23-16-8.64-8.19-10.87-14.82-10.73-19.62a13.37,13.37,0,0,1,.25-2.28,8.37,8.37,0,0,1,12-5.68c10.82,5.5,23.5,23.58,23.5,23.58,13-3,35-5,35-5a26.23,26.23,0,0,0,7.91-1.2,6.42,6.42,0,0,0,3.07-2.14,16,16,0,0,1,8.52-5.73c4.5-1.07.5,2.07.5,2.07-3,2-1,3-1,3,2,2,5-2,5-2,6-4,6,1,6,1,4-1,2,4,2,4C291.29,412.67,289.88,415.43,289.88,415.43Z",
    fill: "#f9b499"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M287.29,407.67a8.46,8.46,0,0,1-5,3,8.57,8.57,0,0,1,5-3Z",
    fill: "#f7a48b"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M289.29,411.67a9.22,9.22,0,0,1-3.77,1.9c-1.53.52-6.61.43-2.22-.45,2-.5,4-1.1,6-1.45Z",
    fill: "#f7a48b"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M289.88,415.44a9.41,9.41,0,0,1-7.59,1.16,35.18,35.18,0,0,1,7.59-1.16Z",
    fill: "#f7a48b"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M284.79,421.17h0c-5.83,2.17-14.5.49-14.5.49-6,0-13,4-13,4a116.11,116.11,0,0,1-37,12c-8,0-23-16-23-16-8.64-8.19-10.87-14.82-10.73-19.62,1.16,2.77,6.07,13.56,14.73,19.62l12,10s-1-9,6-14c0,0-9,12,0,14,0,0,8,5,23-3l18-7s4.57-3.84,10.29-2.42C270.58,419.25,278.29,421.68,284.79,421.17Z",
    fill: "#f7a48b"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.92,
    cy: 342.37,
    rx: 7.75,
    ry: 5,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 43.46, 760.01)",
    fill: "#f9b499"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M678.23,371.74s20.21-1.53,28.64,22.34L722.29,436s9,15-5,21c0,0-20,6-29,15,0,0-10,11-13,3,0,0-3.2-2.72-2.6-5.36,0,0-2.4-7.64,3.6-8.64,0,0,0-4,10-5,0,0,4,1,7-5,0,0,7.15-9.05,12.57-12,0,0-16-25.46-18.78-32.21,0,0-13.55-3.91-12.17-15.34A89.68,89.68,0,0,1,678.23,371.74Z",
    fill: "#f9b499"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M675,389.66s-3.14,11.8,12.07,17c0,0-4.79-7.76-4.79-13.76a13.6,13.6,0,0,0,0,7S676.73,398.38,675,389.66Z",
    fill: "#f7a48b"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5,453.67a15.71,15.71,0,0,1-7.75,3.49l-.23,0s-5.82,1.12-10-2.25c-2.37-1.9-4.22-5.23-4.22-11l-.16-12.2a19.72,19.72,0,0,1,4.62-13.16,7.75,7.75,0,0,1,3.54-2.64h0c.47.14,7.85,2.56,16.1,23,.31.79.64,1.57,1,2.34C688.27,443.11,690.19,448.77,684.5,453.67Z",
    fill: "#ccc"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5,453.67a15.71,15.71,0,0,1-7.75,3.49l-.23,0s-5.82,1.12-10-2.25c0,0,7.27.46,12.25-2.06a8.1,8.1,0,0,0,4.19-8.52c-.92-5.86-4-20.28-12.41-28.2a.07.07,0,0,1,.07-.11c1.51.62,8.29,4.31,15.8,22.85.31.79.64,1.57,1,2.34C688.27,443.11,690.19,448.77,684.5,453.67Z",
    fill: "#b3b3b3"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "677.29 464.95 681.29 460.95 675.29 444.95 675.29 444.95 677.29 464.95",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M133.08,191.93h-94s4.67-6.13,9.81-6.85c0,0,10-29.83,26.79-30,15.6-.19,21.85,18.4,21.85,18.4s7.23-8.32,14.13-4.52,10.82,14.72,10.82,14.72S130.26,187.75,133.08,191.93Z",
    fill: "#ebebeb"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M737.53,280.61h-94s4.67-6.13,9.81-6.84c0,0,10-29.84,26.79-30,15.6-.19,21.85,18.4,21.85,18.4s7.22-8.32,14.13-4.51,10.81,14.71,10.81,14.71S734.71,276.43,737.53,280.61Z",
    fill: "#ebebeb"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M393.49,132.66H512.35s0-7.6-16.38-9.08c0,0-15-33.2-37.77-28.74-14.18,2.78-21.53,22.3-21.53,22.3s-10.75-15.37-19.34-12.39-13.69,19.32-13.69,19.32S394.83,128.37,393.49,132.66Z",
    fill: "#ebebeb"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M311.8,188.46h80.82s-7.63-7.1-11-7.1-13.25-23.83-25.85-22.81-19.35,18.76-19.35,18.76S321,172.49,311.8,188.46Z",
    fill: "#ebebeb"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M98,229.48h69.12s-3.44-4.48-7.23-5c0,0-7.35-21.94-19.7-22.08-11.47-.13-16.07,13.49-16.07,13.49s-5.32-6.13-10.4-3.32-7.94,10.8-7.94,10.8S100,226.4,98,229.48Z",
    fill: "#ebebeb"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M750.42,200.61h69.11s-3.43-4.46-7.22-5c0,0-7.36-21.94-19.71-22.07-11.47-.15-16.06,13.49-16.06,13.49s-5.33-6.13-10.4-3.31-7.95,10.8-7.95,10.8S752.49,197.54,750.42,200.61Z",
    fill: "#ebebeb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 248.31,
    cy: 189.84,
    r: 23.41,
    fill: "#0071f2",
    opacity: 0.5,
    "data-primary": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.53,
    cy: 189.68,
    r: 16.92,
    fill: "#0071f2",
    "data-primary": "true"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M292.1,206.12a27.62,27.62,0,0,1,3.68-1.56,15.34,15.34,0,0,1,4-.92,3.23,3.23,0,0,1,1.23.15,1.84,1.84,0,0,1,.61.34l.43.35a19.56,19.56,0,0,1,1.43,1.45,34.48,34.48,0,0,1,2.46,3.13l-1-.35a27.62,27.62,0,0,1,4-.85,15,15,0,0,1,2.11-.15,5.29,5.29,0,0,1,1.12.09,2.57,2.57,0,0,1,.61.14,5.5,5.5,0,0,1,.6.28,7,7,0,0,1,1.59,1.54,14.47,14.47,0,0,1,1.23,1.68,27.43,27.43,0,0,1,1.89,3.6c-.87-1-1.7-2.08-2.6-3.06a16.49,16.49,0,0,0-1.36-1.41,6.38,6.38,0,0,0-1.42-1.12,3.87,3.87,0,0,0-1.59-.15,14.91,14.91,0,0,0-1.88.26c-1.23.22-2.57.54-3.81.88l-.62.16-.36-.5c-.72-1-1.52-2.07-2.3-3.07a16.33,16.33,0,0,0-1.23-1.41l-.32-.29-.14-.12h0a1.9,1.9,0,0,0-.7-.14,18.16,18.16,0,0,0-3.68.37C294.67,205.6,293.39,205.87,292.1,206.12Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M306.38,244.68a42,42,0,0,1,4.9-3.35,23,23,0,0,1,5.54-2.45,5.08,5.08,0,0,1,1.86-.16,2.67,2.67,0,0,1,.6.16l.4.18a6.3,6.3,0,0,1,.72.4,25.91,25.91,0,0,1,2.56,1.71c1.59,1.23,3.06,2.46,4.54,3.85L326,244.8a46.89,46.89,0,0,1,5.69-2.45,25,25,0,0,1,3.05-.83,11.73,11.73,0,0,1,1.67-.21,7.21,7.21,0,0,1,.93,0,7.64,7.64,0,0,1,1,.24,10.68,10.68,0,0,1,2.8,1.79,30,30,0,0,1,2.24,2.13,39.71,39.71,0,0,1,3.82,4.75c-1.57-1.22-3.12-2.56-4.71-3.75a29.63,29.63,0,0,0-2.46-1.68,9.68,9.68,0,0,0-2.45-1.22,5.45,5.45,0,0,0-2.37.23,21.37,21.37,0,0,0-2.69.93,53.52,53.52,0,0,0-5.34,2.45l-.87.43-.67-.65c-1.31-1.35-2.77-2.57-4.17-3.8-.71-.61-1.44-1.18-2.21-1.72-.17-.11-.37-.24-.54-.33l-.24-.13h-.1a3.14,3.14,0,0,0-1.06,0,28.27,28.27,0,0,0-5.38,1.63C310,243.16,308.2,244,306.38,244.68Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M608.34,155.45a29,29,0,0,1,3.33-2.14,14.82,14.82,0,0,1,3.75-1.54,3.57,3.57,0,0,1,1.22,0,1.91,1.91,0,0,1,.41.11l.27.13.46.27a18.41,18.41,0,0,1,1.67,1.23c1,.84,2,1.74,3,2.67l-1-.18a32.65,32.65,0,0,1,3.85-1.5,15.69,15.69,0,0,1,2-.49,8.47,8.47,0,0,1,1.12-.1H629a5.31,5.31,0,0,1,.65.19,7.44,7.44,0,0,1,1.82,1.22c.51.47,1,1,1.45,1.47a24.7,24.7,0,0,1,2.45,3.25c-1-.88-2-1.77-3-2.6-.51-.41-1-.82-1.58-1.22a6.38,6.38,0,0,0-1.58-.86,3.38,3.38,0,0,0-1.58.11,15.93,15.93,0,0,0-1.82.55c-1.23.44-2.45,1-3.68,1.5l-.59.27-.44-.46c-.88-.9-1.83-1.79-2.77-2.63a15.08,15.08,0,0,0-1.42-1.23l-.36-.23-.17-.1h-.06a2.12,2.12,0,0,0-.71,0,20.14,20.14,0,0,0-3.68,1Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M576,150.21a42,42,0,0,1,3.68-4.65,22.41,22.41,0,0,1,4.56-4,4.78,4.78,0,0,1,1.7-.7,2.22,2.22,0,0,1,.63,0H587a4.15,4.15,0,0,1,.81.16,30.09,30.09,0,0,1,2.94.88c1.89.69,3.68,1.5,5.49,2.35l-1.54.24a46.17,46.17,0,0,1,4.71-4,25.64,25.64,0,0,1,2.67-1.7,10,10,0,0,1,1.53-.7,7.17,7.17,0,0,1,.91-.24,8.18,8.18,0,0,1,1,0,10.86,10.86,0,0,1,3.21.88c1,.41,1.87.88,2.77,1.37a38.2,38.2,0,0,1,5,3.41c-1.88-.75-3.68-1.54-5.61-2.18a26.86,26.86,0,0,0-2.8-.9,9.62,9.62,0,0,0-2.66-.44,5.55,5.55,0,0,0-2.2.92,22.15,22.15,0,0,0-2.29,1.69c-1.51,1.23-3,2.55-4.39,3.88l-.7.67-.84-.42c-1.7-.86-3.48-1.64-5.22-2.45a26.37,26.37,0,0,0-2.61-1l-.61-.16h-.38a3,3,0,0,0-1,.31,29.32,29.32,0,0,0-4.66,3.15C579,147.71,577.54,149,576,150.21Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M260.23,235.2a47,47,0,0,1,3.68-4.63,23.38,23.38,0,0,1,4.56-4,5.38,5.38,0,0,1,1.72-.7,3.31,3.31,0,0,1,.63,0h.44c.27,0,.54.1.81.16a25.32,25.32,0,0,1,2.93.89c1.89.68,3.68,1.48,5.49,2.33l-1.54.25a45,45,0,0,1,4.7-4,25.78,25.78,0,0,1,2.68-1.7,10.69,10.69,0,0,1,1.54-.7,5.44,5.44,0,0,1,.9-.25q.5,0,1,0a10.72,10.72,0,0,1,3.2.88,26.38,26.38,0,0,1,2.77,1.37,37.39,37.39,0,0,1,5.07,3.4c-1.89-.75-3.74-1.53-5.62-2.19-.93-.33-1.86-.65-2.81-.89a9.61,9.61,0,0,0-2.66-.43,5.31,5.31,0,0,0-2.19.92,23.85,23.85,0,0,0-2.3,1.69c-1.5,1.23-3,2.54-4.37,3.88l-.72.67-.83-.42c-1.7-.86-3.47-1.65-5.22-2.45a27.16,27.16,0,0,0-2.6-1,3.42,3.42,0,0,1-.63-.16l-.28-.06h-.1a3.36,3.36,0,0,0-1,.32,29.15,29.15,0,0,0-4.64,3.15C263.26,232.7,261.77,234,260.23,235.2Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6278a64d3ea848eede858eb0046dfd7a.svg";
export { ForwardRef as ReactComponent };